import { computed } from "vue";
import { useRoute } from "vue-router";

import { useAuthenticationStore } from "@/store/authentication.store";

import type { Ref } from "vue";

export const useGlobalOrganisationID = () => {
  const authStore = useAuthenticationStore();
  const selectedMsp = computed(() => authStore.selectedMsp);
  const selectedCustomer = computed(() => authStore.selectedCustomer);
  const selectedAccount = computed(() => authStore.selectedAccount);

  // The URL is the source of truth for which org the data fetches target. Embedded, the host
  // drives navigation through the shared `window.history` and the persisted auth store lags a
  // route change, so reading the store first renders the previous org for a frame. The route
  // param is always correct; the store is only the fallback (legacy paths without an orgUuid).
  const route = useRoute();
  const routeOrgUuid = computed(
    () => (route.params.orgUuid as string | undefined) || null,
  );

  const mspGlobalOrganisationId: Ref<string | null> = computed(
    () =>
      routeOrgUuid.value ||
      selectedMsp.value?.uuid ||
      selectedAccount.value?.uuid ||
      null,
  );
  const customerGlobalOrganisationId: Ref<string | null> = computed(
    () =>
      routeOrgUuid.value ||
      selectedCustomer.value?.uuid ||
      selectedAccount.value?.uuid ||
      null,
  );

  return {
    mspGlobalOrganisationId,
    customerGlobalOrganisationId,
  };
};

export default {};
